import * as React from 'react';
import { Close, Icon } from 'rcd-cpp-ui/ui/icon';
import Typeahead from 'react-bootstrap-typeahead/types/components/Typeahead';
import { Menu, MenuItem } from 'react-bootstrap-typeahead';
import { Pill } from '../Pill/pill';

interface EnumInputProps {
  enumValues: { [x: string]: string };
  selected: string | string[];
  onChange: (vals: string[]) => void;
  onBlur?: () => any;
  multiple?: boolean;
  inlineMenu?: boolean;
  disabled?: boolean;
  disabledOptions?: string[];
}

export const EnumInput: React.FC<EnumInputProps> = ({
  enumValues,
  selected,
  onChange,
  onBlur,
  multiple,
  inlineMenu,
  disabled,
  disabledOptions
}) => {
  const options = Object.keys(enumValues);
  const values = selected
    ? Array.isArray(selected)
      ? selected
      : [selected]
    : [];
  const TMenu = React.useCallback(
    (results: string[]) => {
      if (!results.length) return null;
      return (
        <Menu>
          <div className="ref-search-items">
            {results.map((r, i) => (
              <MenuItem option={r} position={i} key={r}>
                <span onClick={() => onChange(multiple ? [...values, r] : [r])}>
                  <Pill name={enumValues[r] || r} />
                </span>
              </MenuItem>
            ))}
          </div>
        </Menu>
      );
    },
    [onChange]
  );

  return (
    <Typeahead
      id="rs_enum"
      className="reference-search"
      labelKey="label"
      onSearch={() => {}}
      options={options}
      selected={values}
      onBlur={onBlur}
      onChange={onChange}
      renderToken={(o: string, { onRemove }) => (
        <Pill name={enumValues[o] || o} key={o} isSelected={true}>
          {!disabled && !disabledOptions?.includes(o) && (
            <Icon onClick={() => onRemove(o)}>
              <Close />
            </Icon>
          )}
        </Pill>
      )}
      renderMenu={TMenu}
      disabled={disabled}
      multiple={multiple}
      inlineMenu={inlineMenu}
      filterBy={(o: string) => !values.includes(o)}
    />
  );
};
